// extracted by mini-css-extract-plugin
module.exports = {"logo":"Contacts_logo__1eyrp","description":"Contacts_description__36iAr"};